import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';
import type { ISetAdherenceReasonRequest } from '@/api/types';

import { CardContainer, HeaderLabel, RowsContainer } from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { COMPLIANCE_CONFIG_TABLE } from '@/constants/contracts';
import { LoaderWrapper, ReasonRow, ReasonsCardSkeleton } from '@/components/common';

interface IProps {
  rowsToDisplay: IGigComplianceRow[];
  handleSaveReason: (
    payload: Omit<ISetAdherenceReasonRequest, 'contractId' | 'selectedWeekId'>,
    closeModal: () => void,
  ) => void;
  isLoading: boolean;
}

const ReasonsCard = ({ rowsToDisplay, handleSaveReason, isLoading }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <CardContainer width={COMPLIANCE_CONFIG_TABLE.reason.width}>
      <LoaderWrapper className="h-100" isLoading={isLoading} loader={<ReasonsCardSkeleton />}>
        <HeaderLabel>{t`gigCompliance.complianceTable.labelReason`}</HeaderLabel>
        <RowsContainer
          colorOne={COMPLIANCE_CONFIG_TABLE.reason.colorOne}
          colorTwo={COMPLIANCE_CONFIG_TABLE.reason.colorTwo}
          colorText={COMPLIANCE_CONFIG_TABLE.reason.colorText}
        >
          {rowsToDisplay.map(row => (
            <ReasonRow key={`reason-${row.weekId}`} row={row} onSubmit={handleSaveReason} />
          ))}
        </RowsContainer>
      </LoaderWrapper>
    </CardContainer>
  );
};

export { ReasonsCard };
